import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_background = _resolveComponent("app-background")!
  const _component_awaiting_activation = _resolveComponent("awaiting-activation")!
  const _component_side_menu = _resolveComponent("side-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_dev_box = _resolveComponent("dev-box")!
  const _component_toast = _resolveComponent("toast")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_app_background, {
        class: "App_background",
        style: {"display":"none"}
      }),
      (_ctx.store.state.isAccountAwaitingActivation)
        ? (_openBlock(), _createBlock(_component_awaiting_activation, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_side_menu, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_router_outlet, { id: "main" })
          ], 64)),
      false
        ? (_openBlock(), _createBlock(_component_dev_box, { key: 2 }, {
            default: _withCtx(() => [
              _createTextVNode(" isAccountAwaitingActivation: " + _toDisplayString(_ctx.store.state.isAccountAwaitingActivation), 1),
              _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_toast, {
        position: "top-center",
        onClick: _ctx.handleToastClick
      }, null, 8, ["onClick"])
    ]),
    _: 1
  }))
}